import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Select } from 'semantic-ui-react';

const months = {
  '01': '01',
  '02': '02',
  '03': '03',
  '04': '04',
  '05': '05',
  '06': '06',
  '07': '07',
  '08': '08',
  '09': '09',
  '10': '10',
  '11': '11',
  '12': '12',
};

class DateOfBirth extends Component {
  static propTypes = {
    fieldChangeHandler: PropTypes.func,
    member: PropTypes.object,
    readOnly: PropTypes.bool,
    memberLevel: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      birthMonths: this.getBirthMonths(),
      birthDates: this.getBirthDates(),
      birthYears: this.getBirthYears(),
    };
  }

  getBirthMonths = () => {
    const birthMonths = [];
    birthMonths.push({ key: '', value: '', text: '' });
    for (let i = 1; i <= 12; i += 1) {
      let value = i.toString();
      if (i < 10) {
        value = `0${value}`;
      }

      birthMonths.push({ key: value, value, text: months[value] });
    }
    return birthMonths;
  }

  getBirthDates = () => {
    const birthDates = [];
    birthDates.push({ key: '', value: '', text: '' });
    for (let i = 1; i <= 31; i += 1) {
      let value = i.toString();
      if (i < 10) {
        value = `0${value}`;
      }

      birthDates.push({ key: value, value, text: value });
    }
    return birthDates;
  }

  getBirthYears = () => {
    const birthYears = [];
    birthYears.push({ key: '', value: '', text: '' });
    for (let i = 1900; i < (new Date()).getFullYear(); i += 1) {
      birthYears.push({ key: i.toString(), value: i.toString(), text: i.toString() });
    }
    return birthYears;
  }

  render() {
    const { member, fieldChangeHandler, readOnly, memberLevel } = this.props;
    const { birthMonths, birthDates, birthYears } = this.state;

    let birthMonthValue = 'birthMonth';
    let birthDayValue = 'birthDay';
    let birthYearValue = 'birthYear';
    if (memberLevel === 'primary') {
      birthMonthValue = 'birthMonth';
      birthDayValue = 'birthDay';
      birthYearValue = 'birthYear';
    } else if (memberLevel === 'spouse') {
      birthMonthValue = 'spouseBirthMonth';
      birthDayValue = 'spouseBirthDay';
      birthYearValue = 'spouseBirthYear';
    }

    return (
      <Form.Field label="Date of Birth (MM/DD/YYYY)" control={Input}>
        {readOnly !== true ?
          <Form.Group>
            <Form.Field
              control={Select}
              placeholder="Month"
              value={member[birthMonthValue]}
              onChange={fieldChangeHandler}
              name={birthMonthValue}
              options={birthMonths}
              style={{ minWidth: '100px' }}
              search
            />
            <Form.Field
              control={Select}
              placeholder="Day"
              value={member[birthDayValue]}
              onChange={fieldChangeHandler}
              name={birthDayValue}
              options={birthDates}
              style={{ minWidth: '100px' }}
              search
            />
            <Form.Field
              control={Select}
              placeholder="Year"
              value={member[birthYearValue]}
              onChange={fieldChangeHandler}
              name={birthYearValue}
              options={birthYears}
              style={{ minWidth: '100px' }}
              search
            />
          </Form.Group>
          :
          <Form.Group>
            <Form.Field
              control={Input}
              placeholder="Month"
              value={months[member[birthMonthValue]] || ''}
              name={birthMonthValue}
              style={{ width: '100px' }}
              readOnly
            />
            <Form.Field
              control={Input}
              placeholder="Day"
              value={member[birthDayValue]}
              name={birthDayValue}
              style={{ width: '100px' }}
              readOnly
            />
            <Form.Field
              control={Input}
              placeholder="Year"
              value={member[birthYearValue]}
              name={birthYearValue}
              style={{ width: '100px' }}
              readOnly
            />
          </Form.Group>
        }
      </Form.Field>
    );
  }
}

export default DateOfBirth;



// WEBPACK FOOTER //
// ./src/app/components/DateOfBirth/index.js